import Axios from 'axios'
const BaseURL = process.env.VUE_APP_BASE_URL

export default {
    name: 'phoneCodes',
    state: {
        codeList: []
    },
    getters: {
        getPhoneCodes: state => {
            return state.codeList
        }
    },
    mutations: {
        ADD_CODES: (state, payload) => {
            state.codeList = payload
        }
    },
    actions: {
        Fetch_PhoneCodes(store) {
            return Axios({
                method: "get",
                url: BaseURL + "./json/CountryCodes.json"
            }).then(response => {
                store.commit('ADD_CODES', response.data);
            }).catch(err => {
                return err
            });
        },
    }
}